// src/components/admin/DivisionsList.js
import React from 'react';
import RefDictionaryPage from './RefDictionaryPage';

export default function DivisionsList() {
  return (
    <RefDictionaryPage
      breadcrumbs="Справочники"
      title="Подразделения"
      subtitle="Филиалы и склады организаций"
      endpoint="v1/divisions"
      listMapper={(raw) => (Array.isArray(raw) ? raw.filter((d) => !d.is_deleted) : [])}
      searchKeys={['name', 'address']}
      extraRefs={{ orgs: 'v1/organizations' }}
      columns={[
        { key: 'id', label: 'ID', width: 80 },
        { key: 'name', label: 'Название' },
        { key: 'address', label: 'Адрес', wrap: true },
        {
          key: 'id_organization',
          label: 'Организация',
          width: 180,
          render: (v, _row, refs) => {
            const org = (refs?.orgs || []).find((o) => String(o.id) === String(v));
            return org ? <span className="crmpage__primary">{org.name}</span> : '—';
          },
        },
        {
          key: 'is_active',
          label: 'Статус',
          width: 110,
          render: (v) => (
            <span className={`crmpage__status crmpage__status--${v ? 'success' : 'neutral'}`}>
              {v ? 'Активно' : 'Отключено'}
            </span>
          ),
        },
      ]}
      fields={[
        { key: 'name', label: 'Название', required: true },
        { key: 'address', label: 'Адрес', type: 'textarea' },
        { key: 'id_organization', label: 'Организация', type: 'select', refsKey: 'orgs', required: true },
        { key: 'is_active', label: 'Статус', type: 'select', options: [
          { id: 'true',  name: 'Активно' },
          { id: 'false', name: 'Отключено' },
        ] },
      ]}
      emptyRecord={{ name: '', address: '', id_organization: '', is_active: 'true' }}
    />
  );
}
